module.exports = __webpack_public_path__ + "static/img/graymore_pictgrid4_850x618.060878d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/graymore_pictgrid4_850x618.jpg
// module id = lC1b
// module chunks = 0